import { scrollToId } from "@/hooks/useLenis";

export const Footer = () => {
  return (
    <footer className="bg-vnavy border-t border-white/10 py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="inline-flex items-center bg-white rounded-xl px-4 py-2.5 shadow-lg shadow-black/20">
                <img src="/logo-vertice-h.webp" alt="Grupo Vértice CR" className="h-12 w-auto object-contain" />
              </span>
            </div>
            <p className="text-gray-500 text-sm leading-relaxed max-w-xs">
              Recursos Humanos, Asesoría Legal Laboral y Contabilidad, integrados en un solo aliado corporativo.
            </p>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-vteal-light font-semibold mb-5">Navegación</h4>
            <ul className="space-y-3 text-sm">
              {[
                { label: "Inicio", id: "inicio" },
                { label: "Nosotros", id: "nosotros" },
                { label: "Servicios", id: "servicios" },
                { label: "Formalización", id: "formalizacion" },
                { label: "Suscripción", id: "planes" },
                { label: "Acceso a Sistemas", id: "plataformas" },
                { label: "Contacto", id: "contacto" },
              ].map((l) => (
                <li key={l.id}>
                  <button onClick={() => scrollToId(l.id)} className="text-gray-400 hover:text-white transition-colors">
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-vteal-light font-semibold mb-5">Plataformas</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a href="https://rrhh.grupoverticecr.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
                  Sistema de Recursos Humanos
                </a>
              </li>
              <li>
                <a href="https://legal.grupoverticecr.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
                  Sistema de Despacho Legal
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-600 text-xs">© {new Date().getFullYear()} Grupo Vértice CR. Todos los derechos reservados.</p>
          <p className="text-gray-600 text-xs">San José, Costa Rica</p>
        </div>
      </div>
    </footer>
  );
};
